/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2022-11-14 08:39:08
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-14 10:23:23
 */
const title = '湖北长江互联网教育研究院职业技能等级考试系统'
const getTitle = function(til) {
  console.log(til)
  // let allTitle = til + ' - ' + title
  let allTitle = title
  return allTitle
}
export default getTitle
